// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export var successStates = ["succeeded"];
export var failureStates = ["failed", "canceled", "cancelled"];
/**
 * The LRO states that signal that the LRO has completed.
 */

export var terminalStates = successStates.concat(failureStates);